import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSetRecoilState, useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import TitleFlex from "../../vendasDigitadas/defaultComponents/titleFlex";
import {
  CNPJFormater,
  CPFFormater,
} from "../../../../defaultFunctions/formaters";
import { dateForList, dateForAPI } from "../../../../constants/dataFormat";
import copy from "copy-to-clipboard";
import { goToVendaBolePixListagem } from "../../../../routes/coordinator";
import { customColors } from "../../../../atoms/customColors";
import { toast } from "react-toastify";
import VendasBoletoIndividualApi from "../../../../services/VendasBoletoIndividuaApi";

interface ModalRevisãoVendaBoletoLoteProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  batchObjects: any[];
  setBatchObjects: (objects: any[]) => void;
  setBatchResponses: (responses: any[]) => void;
  setBoleto: (boleto: any) => void;
  initialValues: any;
  setLoadingState: (loading: boolean) => void;
  numBoletos: number;
  cliente: number;
  idLogin: number;
}

export default function ModalRevisãoVendaBoletoLote({
  isOpen,
  setIsOpen,
  batchObjects,
  setBatchObjects,
  setBatchResponses,
  setBoleto,
  initialValues,
  setLoadingState,
  numBoletos,
  cliente,
  idLogin,
}: ModalRevisãoVendaBoletoLoteProps) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const colors = useRecoilState(customColors)[0];
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [localBatchResponses, setLocalBatchResponses] = useState<any[]>([]);
  const [loadingState, setLocalLoadingState] = useState(false);

  const onClose = () => {
    setIsOpen(false);
    setIsConfirmed(false);
    setLocalBatchResponses([]);
    setBatchObjects([]);
    setBoleto(initialValues);
    goToVendaBolePixListagem(navigate);
  };

  const handleConfirm = async () => {
    setLocalLoadingState(true);
    setLoadingState(true);
    const responses: any[] = [];
    try {
      const lotePayload = {
        idCliente: cliente,
        idLogin: idLogin,
        diaVencimento: moment(batchObjects[0].vencimento).date(),
        parcelas: numBoletos,
        isCancelado: false,
        dataPrimeiraEmissao: moment(batchObjects[0].vencimento).format(
          dateForAPI
        ),
        mensagem: "Lote de boletos assinatura",
        boletoBase: {
          idLogin: idLogin,
          idCliente: cliente,
          dataVencimento: moment(batchObjects[0].vencimento).format(dateForAPI),
          dataEmissao: moment().format(dateForAPI),
          isAvulso: false,
          valor: batchObjects[0].valor,
          mensagem: batchObjects[0].descricao,
          cpfPagador: batchObjects[0].cpfPagador,
          nomePagador: batchObjects[0].nomePagador,
          emailPagador: batchObjects[0].emailPagador,
          enderRua: batchObjects[0].enderRua,
          enderBairro: batchObjects[0].enderBairro,
          enderCEP: batchObjects[0].enderCEP,
          enderCidade: batchObjects[0].enderCidade,
          enderComplemento: batchObjects[0].enderComplemento,
          enderEstado: batchObjects[0].enderEstado,
          enderNumero: batchObjects[0].enderNumero,
          enderReferencia: batchObjects[0].enderReferencia,
          permitirRegras: batchObjects[0].permitirRegras,
          RegrasJuros: {
            mode: batchObjects[0].RegrasJuros.mode,
            amount: batchObjects[0].RegrasJuros.amount,
            percentage: batchObjects[0].RegrasJuros.percentage,
            start_date: moment(batchObjects[0].vencimento).format(dateForAPI),
          },
          RegrasMulta: {
            mode: batchObjects[0].RegrasMulta.mode,
            amount: batchObjects[0].RegrasMulta.amount,
            percentage: batchObjects[0].RegrasMulta.percentage,
            start_date: moment(batchObjects[0].vencimento).format(dateForAPI),
          },
        },
      };

      for (let i = 0; i < numBoletos; i++) {
        const dueDate = moment(batchObjects[0].vencimento)
          .add(i, "months")
          .format(dateForAPI);
        const boletoPayload = {
          ...lotePayload,
          boletoBase: {
            ...lotePayload.boletoBase,
            dataVencimento: dueDate,
            mensagem: `${batchObjects[0].descricao} - Parcela ${i + 1}`,
            RegrasJuros: {
              ...lotePayload.boletoBase.RegrasJuros,
              start_date: dueDate,
            },
            RegrasMulta: {
              ...lotePayload.boletoBase.RegrasMulta,
              start_date: dueDate,
            },
          },
        };

        const response = await VendasBoletoIndividualApi.postVendaBolePix(
          boletoPayload
        );
        responses.push(response);
        toast.success(`Boleto ${i + 1} criado com sucesso!`);
      }

      setLocalBatchResponses(responses);
      setBatchResponses(responses);
      setIsConfirmed(true);
      toast.success("Todos os boletos foram criados com sucesso!");
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data._error) {
        const { message, reasons } = error.response.data._error.error;
        const errorTranslations: { [key: string]: string } = {
          "Late fee mode is not valid": "O modo de multa está inválido",
          "Late fee start date must be greater than the expiration date":
            "A data de início da multa deve ser maior que a data de vencimento",
          "Interest mode is not valid": "O modo de juros está inválido",
          "Invalid value fields": "Campos de valor inválidos",
          "Amount is more than limit": "O valor excede o limite permitido",
        };
        const translatedReasons = reasons.map(
          (reason: string) => errorTranslations[reason] || reason
        );
        toast.error(
          `Erro ao gerar boletos: ${message}. Motivos: ${translatedReasons.join(
            "; "
          )}`
        );
      } else {
        const errorMessage =
          error.response?.data?.message || JSON.stringify(error);
        toast.error(errorMessage);
      }
    } finally {
      setLocalLoadingState(false);
      setLoadingState(false);
    }
  };

  return (
    <Modal
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      size={"xl"}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader>
          <Flex w={"100%"} justifyContent={"center"}>
            <Text fontWeight={"bold"} color={colors.GREENMONEDD}>
              {isConfirmed
                ? "Lote de Boletos Criado com Sucesso!"
                : "Revisar Lote de Boletos"}
            </Text>
          </Flex>
        </ModalHeader>
        <ModalBody>
          {batchObjects.length > 0 && (
            <>
              <TitleFlex item={"Resumo do Lote"} />
              <Flex flexDir={"column"} px={4}>
                <Text>
                  <strong>Número de Boletos:</strong> {numBoletos}
                </Text>
                <Text>
                  <strong>Valor Total:</strong>{" "}
                  {(batchObjects[0].valor * numBoletos).toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )}
                </Text>
                <Text>
                  <strong>Valor por Boleto:</strong>{" "}
                  {batchObjects[0].valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Text>
                <Text>
                  <strong>Descrição Base:</strong> {batchObjects[0].descricao}
                </Text>
              </Flex>

              <TitleFlex item={"Datas de Vencimento"} />
              <Table variant="simple" size="sm">
                <Thead>
                  <Tr>
                    <Th>Parcela</Th>
                    <Th>Data de Vencimento</Th>
                    <Th>Descrição</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {batchObjects.map((obj, index) => (
                    <Tr key={index}>
                      <Td>{index + 1}</Td>
                      <Td>{moment(obj.vencimento).format(dateForList)}</Td>
                      <Td>{obj.descricao}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>

              <TitleFlex item={"Dados do Pagador"} />
              <Flex flexDir={"column"} px={4}>
                <Text>Nome do Pagador: {batchObjects[0].nomePagador}</Text>
                <Text>
                  Documento do Pagador:{" "}
                  {batchObjects[0].cpfPagador.length === 11
                    ? CPFFormater(batchObjects[0].cpfPagador)
                    : CNPJFormater(batchObjects[0].cpfPagador)}
                </Text>
                <Text>Email: {batchObjects[0].emailPagador}</Text>
              </Flex>

              <TitleFlex item={"Endereço de Cobrança"} />
              <Flex flexDir={"column"} px={4}>
                <Text>
                  {`${batchObjects[0].enderRua}, ${batchObjects[0].enderNumero}/${batchObjects[0].enderBairro}-${batchObjects[0].enderCidade}-${batchObjects[0].enderEstado}`}
                </Text>
                <Text>CEP: {batchObjects[0].enderCEP}</Text>
              </Flex>

              {batchObjects[0].permitirRegras && (
                <>
                  <TitleFlex item={"Regras de Juros e Multa"} />
                  <Flex flexDir={"column"} px={4}>
                    <Text>
                      Juros:{" "}
                      {batchObjects[0].RegrasJuros.mode === "SEM_JUROS"
                        ? "Sem Juros"
                        : `${
                            batchObjects[0].RegrasJuros.mode === "DAILY_AMOUNT"
                              ? "Valor Diário"
                              : batchObjects[0].RegrasJuros.mode ===
                                "DAILY_PERCENTAGE"
                              ? "Percentual Diário"
                              : "Percentual Mensal"
                          }: ${
                            batchObjects[0].RegrasJuros.amount ||
                            batchObjects[0].RegrasJuros.percentage
                          }`}
                    </Text>
                    <Text>
                      Multa:{" "}
                      {batchObjects[0].RegrasMulta.mode === "SEM_MULTA"
                        ? "Sem Multa"
                        : `${
                            batchObjects[0].RegrasMulta.mode === "FIXED"
                              ? "Valor Fixo"
                              : "Percentual"
                          }: ${
                            batchObjects[0].RegrasMulta.amount ||
                            batchObjects[0].RegrasMulta.percentage
                          }`}
                    </Text>
                  </Flex>
                </>
              )}

              {isConfirmed && localBatchResponses.length > 0 && (
                <>
                  <TitleFlex item={"Resultados do Lote"} />
                  <Table variant="simple" size="sm">
                    <Thead>
                      <Tr>
                        <Th>Parcela</Th>
                        <Th>Código de Barras</Th>
                        <Th>ID da Transação</Th>
                        <Th>Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {localBatchResponses.map((response, index) => (
                        <Tr key={index}>
                          <Td>{index + 1}</Td>
                          <Td fontSize={"12px"}>{response.barcode}</Td>
                          <Td>{response.idTransacao}</Td>
                          <Td>
                            <Button
                              size="sm"
                              bgColor={colors.VARIANT}
                              color={colors.WHITE}
                              onClick={() => copy(response.barcode || "")}
                            >
                              Copiar Código de Barras
                            </Button>
                            <Button
                              size="sm"
                              ml={2}
                              bgColor={colors.VARIANT}
                              color={colors.WHITE}
                              as="a"
                              href={response.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Abrir Boleto
                            </Button>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter justifyContent={"space-evenly"}>
          {!isConfirmed ? (
            <>
              <Button
                background={colors.GRAY}
                color={"white"}
                mr={3}
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={colors.WHITE}
                isDisabled={loadingState}
                onClick={handleConfirm}
              >
                {loadingState ? (
                  <Spinner size="sm" />
                ) : (
                  `Confirmar Criação de ${numBoletos} Boleto${
                    numBoletos > 1 ? "s" : ""
                  }`
                )}
              </Button>
            </>
          ) : (
            <>
              <Button
                background={colors.GRAY}
                color={"white"}
                mr={3}
                onClick={onClose}
              >
                Fechar
              </Button>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
